import PropTypes from 'prop-types';
import React from 'react';

import Action from 'brastrap/common/action/Action';

/* For type-correctness, we expect numbers for the 'yes' and 'no' props, however
 * the Icon component that Action uses expects strings for its labels...so we
 * convert them with String.
 */
const Vote = props => (
  <section className="c-vote">
    <h1 className="c-vote__title">{props.title}</h1>
    <Action
      icon={{
        icon: 'thumbs-up',
        ariaLabel: 'Yes',
        label: String(props.yes),
        labelled: 'end',
      }}
      modifiers={['positive']}
      onClick={props.onClickYes}
    />
    <Action
      icon={{
        icon: 'thumbs-down',
        ariaLabel: 'No',
        label: String(props.no),
        labelled: 'end',
      }}
      modifiers={['negative']}
      onClick={props.onClickNo}
    />
  </section>
);

Vote.propTypes = {
  title: PropTypes.string.isRequired,
  yes: PropTypes.number.isRequired,
  no: PropTypes.number.isRequired,
  onClickYes: PropTypes.func.isRequired,
  onClickNo: PropTypes.func.isRequired,
};

export default Vote;
